/* tslint:disable */
/* eslint-disable */
/**
 * Coworker IAM API
 * Provides coworker identity and access management functionalities
 *
 * The version of the OpenAPI document: 1.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AtkomstNodeDto,
  AuthorizeResponseDto,
  CoworkerPermissionsDto,
  MessageResponseDto,
  PreferencesDto,
  PrinterPreferencesDto,
} from '../models/index';
import {
    AtkomstNodeDtoFromJSON,
    AtkomstNodeDtoToJSON,
    AuthorizeResponseDtoFromJSON,
    AuthorizeResponseDtoToJSON,
    CoworkerPermissionsDtoFromJSON,
    CoworkerPermissionsDtoToJSON,
    MessageResponseDtoFromJSON,
    MessageResponseDtoToJSON,
    PreferencesDtoFromJSON,
    PreferencesDtoToJSON,
    PrinterPreferencesDtoFromJSON,
    PrinterPreferencesDtoToJSON,
} from '../models/index';

export interface CoworkerIamControllerCheckCoworkerPermissionRequest {
    x_bucode: string;
    permissionName: string;
    x_request_id?: string;
    x_countrycode?: string;
    x_locale?: string;
}

export interface CoworkerIamControllerGetCoworkerPermissionNodesRequest {
    permissionName: string;
    x_request_id?: string;
    x_bucode?: string;
    x_countrycode?: string;
    x_locale?: string;
    nodeTypes?: string;
    roots?: string;
}

export interface CoworkerIamControllerGetCoworkerPermissionsRequest {
    x_bucode: string;
    x_request_id?: string;
    x_countrycode?: string;
    x_locale?: string;
}

export interface CoworkerIamControllerGetCoworkerPrintersRequest {
    x_request_id?: string;
    x_bucode?: string;
    x_countrycode?: string;
    x_locale?: string;
}

export interface CoworkerIamControllerGetOrSyncCoworkerPreferencesRequest {
    x_request_id?: string;
    x_bucode?: string;
    x_countrycode?: string;
    x_locale?: string;
}

export interface CoworkerIamControllerSetCoworkerPreferencesRequest {
    PreferencesDto: PreferencesDto;
    x_request_id?: string;
    x_bucode?: string;
    x_countrycode?: string;
    x_locale?: string;
}

/**
 * 
 */
export class CoworkerApi extends runtime.BaseAPI {

    /**
     * Checks whether the authenticated coworker has the given permission on the specified store node via Åtkomst
     * Checks if coworker has a specific permission on a store
     */
    async coworkerIamControllerCheckCoworkerPermissionRaw(requestParameters: CoworkerIamControllerCheckCoworkerPermissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthorizeResponseDto>> {
        if (requestParameters['x_bucode'] == null) {
            throw new runtime.RequiredError(
                'x_bucode',
                'Required parameter "x_bucode" was null or undefined when calling coworkerIamControllerCheckCoworkerPermission().'
            );
        }

        if (requestParameters['permissionName'] == null) {
            throw new runtime.RequiredError(
                'permissionName',
                'Required parameter "permissionName" was null or undefined when calling coworkerIamControllerCheckCoworkerPermission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['x_request_id'] != null) {
            headerParameters['x-request-id'] = String(requestParameters['x_request_id']);
        }

        if (requestParameters['x_bucode'] != null) {
            headerParameters['x-bucode'] = String(requestParameters['x_bucode']);
        }

        if (requestParameters['x_countrycode'] != null) {
            headerParameters['x-countrycode'] = String(requestParameters['x_countrycode']);
        }

        if (requestParameters['x_locale'] != null) {
            headerParameters['x-locale'] = String(requestParameters['x_locale']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/coworker/authorize/{permissionName}`.replace(`{${"permissionName"}}`, encodeURIComponent(String(requestParameters['permissionName']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthorizeResponseDtoFromJSON(jsonValue));
    }

    /**
     * Checks whether the authenticated coworker has the given permission on the specified store node via Åtkomst
     * Checks if coworker has a specific permission on a store
     */
    async coworkerIamControllerCheckCoworkerPermission(requestParameters: CoworkerIamControllerCheckCoworkerPermissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthorizeResponseDto> {
        const response = await this.coworkerIamControllerCheckCoworkerPermissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all nodes (stores) where the authenticated coworker has the given permission via Åtkomst
     * Fetches stores where coworker has a specific permission
     */
    async coworkerIamControllerGetCoworkerPermissionNodesRaw(requestParameters: CoworkerIamControllerGetCoworkerPermissionNodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AtkomstNodeDto>>> {
        if (requestParameters['permissionName'] == null) {
            throw new runtime.RequiredError(
                'permissionName',
                'Required parameter "permissionName" was null or undefined when calling coworkerIamControllerGetCoworkerPermissionNodes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['nodeTypes'] != null) {
            queryParameters['nodeTypes'] = requestParameters['nodeTypes'];
        }

        if (requestParameters['roots'] != null) {
            queryParameters['roots'] = requestParameters['roots'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['x_request_id'] != null) {
            headerParameters['x-request-id'] = String(requestParameters['x_request_id']);
        }

        if (requestParameters['x_bucode'] != null) {
            headerParameters['x-bucode'] = String(requestParameters['x_bucode']);
        }

        if (requestParameters['x_countrycode'] != null) {
            headerParameters['x-countrycode'] = String(requestParameters['x_countrycode']);
        }

        if (requestParameters['x_locale'] != null) {
            headerParameters['x-locale'] = String(requestParameters['x_locale']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/coworker/nodes/{permissionName}`.replace(`{${"permissionName"}}`, encodeURIComponent(String(requestParameters['permissionName']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AtkomstNodeDtoFromJSON));
    }

    /**
     * Retrieves all nodes (stores) where the authenticated coworker has the given permission via Åtkomst
     * Fetches stores where coworker has a specific permission
     */
    async coworkerIamControllerGetCoworkerPermissionNodes(requestParameters: CoworkerIamControllerGetCoworkerPermissionNodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AtkomstNodeDto>> {
        const response = await this.coworkerIamControllerGetCoworkerPermissionNodesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves list of permissions for the authenticated coworker from Åtkomst
     * Fetches coworker permissions for given buCode
     */
    async coworkerIamControllerGetCoworkerPermissionsRaw(requestParameters: CoworkerIamControllerGetCoworkerPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CoworkerPermissionsDto>> {
        if (requestParameters['x_bucode'] == null) {
            throw new runtime.RequiredError(
                'x_bucode',
                'Required parameter "x_bucode" was null or undefined when calling coworkerIamControllerGetCoworkerPermissions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['x_request_id'] != null) {
            headerParameters['x-request-id'] = String(requestParameters['x_request_id']);
        }

        if (requestParameters['x_bucode'] != null) {
            headerParameters['x-bucode'] = String(requestParameters['x_bucode']);
        }

        if (requestParameters['x_countrycode'] != null) {
            headerParameters['x-countrycode'] = String(requestParameters['x_countrycode']);
        }

        if (requestParameters['x_locale'] != null) {
            headerParameters['x-locale'] = String(requestParameters['x_locale']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/coworker/permissions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CoworkerPermissionsDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves list of permissions for the authenticated coworker from Åtkomst
     * Fetches coworker permissions for given buCode
     */
    async coworkerIamControllerGetCoworkerPermissions(requestParameters: CoworkerIamControllerGetCoworkerPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CoworkerPermissionsDto> {
        const response = await this.coworkerIamControllerGetCoworkerPermissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrives the list of recently used printers, ordered by most recent
     * Fetches recently used printers for coworker, ordered by most recent
     */
    async coworkerIamControllerGetCoworkerPrintersRaw(requestParameters: CoworkerIamControllerGetCoworkerPrintersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PrinterPreferencesDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['x_request_id'] != null) {
            headerParameters['x-request-id'] = String(requestParameters['x_request_id']);
        }

        if (requestParameters['x_bucode'] != null) {
            headerParameters['x-bucode'] = String(requestParameters['x_bucode']);
        }

        if (requestParameters['x_countrycode'] != null) {
            headerParameters['x-countrycode'] = String(requestParameters['x_countrycode']);
        }

        if (requestParameters['x_locale'] != null) {
            headerParameters['x-locale'] = String(requestParameters['x_locale']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/coworker/printers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrinterPreferencesDtoFromJSON(jsonValue));
    }

    /**
     * Retrives the list of recently used printers, ordered by most recent
     * Fetches recently used printers for coworker, ordered by most recent
     */
    async coworkerIamControllerGetCoworkerPrinters(requestParameters: CoworkerIamControllerGetCoworkerPrintersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PrinterPreferencesDto> {
        const response = await this.coworkerIamControllerGetCoworkerPrintersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves preferences for the authenticated coworker
     * Fetches coworker preferences
     */
    async coworkerIamControllerGetOrSyncCoworkerPreferencesRaw(requestParameters: CoworkerIamControllerGetOrSyncCoworkerPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PreferencesDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['x_request_id'] != null) {
            headerParameters['x-request-id'] = String(requestParameters['x_request_id']);
        }

        if (requestParameters['x_bucode'] != null) {
            headerParameters['x-bucode'] = String(requestParameters['x_bucode']);
        }

        if (requestParameters['x_countrycode'] != null) {
            headerParameters['x-countrycode'] = String(requestParameters['x_countrycode']);
        }

        if (requestParameters['x_locale'] != null) {
            headerParameters['x-locale'] = String(requestParameters['x_locale']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/coworker/preferences`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PreferencesDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves preferences for the authenticated coworker
     * Fetches coworker preferences
     */
    async coworkerIamControllerGetOrSyncCoworkerPreferences(requestParameters: CoworkerIamControllerGetOrSyncCoworkerPreferencesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PreferencesDto> {
        const response = await this.coworkerIamControllerGetOrSyncCoworkerPreferencesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sets preferences for the authenticated coworker and marks it as current
     * Sets coworker preferences
     */
    async coworkerIamControllerSetCoworkerPreferencesRaw(requestParameters: CoworkerIamControllerSetCoworkerPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MessageResponseDto>> {
        if (requestParameters['PreferencesDto'] == null) {
            throw new runtime.RequiredError(
                'PreferencesDto',
                'Required parameter "PreferencesDto" was null or undefined when calling coworkerIamControllerSetCoworkerPreferences().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['x_request_id'] != null) {
            headerParameters['x-request-id'] = String(requestParameters['x_request_id']);
        }

        if (requestParameters['x_bucode'] != null) {
            headerParameters['x-bucode'] = String(requestParameters['x_bucode']);
        }

        if (requestParameters['x_countrycode'] != null) {
            headerParameters['x-countrycode'] = String(requestParameters['x_countrycode']);
        }

        if (requestParameters['x_locale'] != null) {
            headerParameters['x-locale'] = String(requestParameters['x_locale']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/coworker/preferences`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PreferencesDtoToJSON(requestParameters['PreferencesDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MessageResponseDtoFromJSON(jsonValue));
    }

    /**
     * Sets preferences for the authenticated coworker and marks it as current
     * Sets coworker preferences
     */
    async coworkerIamControllerSetCoworkerPreferences(requestParameters: CoworkerIamControllerSetCoworkerPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MessageResponseDto> {
        const response = await this.coworkerIamControllerSetCoworkerPreferencesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
